import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceBehfaFilterGroupService } from 'src/app/Service/DeviceBehfaFilterGroup/DeviceBehfaFilterGroup.service';

@Component({
  selector: 'app-DeviceBehfaFilterGroupDetail',
  templateUrl: './DeviceBehfaFilterGroupDetail.component.html',
  styleUrls: ['./DeviceBehfaFilterGroupDetail.component.css']
})
export class DeviceBehfaFilterGroupDetailComponent implements OnInit {

  @Input() inner_DeviceBehfaFilterGroup: General_Interface = Empty_General_Interface()
  @Output() outter_DeviceBehfaFilterGroup = new EventEmitter<number>();
  Filter_title: string = ""
  page: number = 0;
  Procssing: boolean = false

  modalRef_Delete: any;

  constructor(
    private DeviceBehfaFilterGroup_Service: DeviceBehfaFilterGroupService,
    private Alertify_Service: AlertifyService,
    private modalService: BsModalService,

  ) { }


  DataList_DeviceBehfaFilterGroupUser: Array<DeviceBehfa_Interface> = []

  ngOnInit() {
    this.ReadData_DeviceBehfaFilterGroupUser()


  }

  ReadData_DeviceBehfaFilterGroupUser() {
    this.Procssing = true
    this.DeviceBehfaFilterGroup_Service.GetDeviceBehfa(this.inner_DeviceBehfaFilterGroup.id).subscribe(
      data => {
        this.DataList_DeviceBehfaFilterGroupUser = data
        this.Procssing = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter_title() {
    this.page = 0
  }

  Delete(item: DeviceBehfa_Interface) {
    this.Procssing = true

    this.DeviceBehfaFilterGroup_Service.DeleteDeviceBehfa(item.id).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("حذف شد")
        this.ReadData_DeviceBehfaFilterGroupUser()
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }


  onBack() {
    this.outter_DeviceBehfaFilterGroup.emit(-1);
  }

  //#region DeviceBehfa


  DataList_DeviceBehfa_Schedule: Array<string> = []
  modalRef_DeviceBehfa: any;
  modalRef_DeviceBehfaSchedule: any;

  openModal_DeviceBehfa(template: TemplateRef<any>) {
    this.modalRef_DeviceBehfa = this.modalService.show(template);
  }

  Set_Selected_DeviceBehfa_Record(item: DeviceBehfa_Interface) {
    this.Procssing = true

    this.DeviceBehfaFilterGroup_Service.AddDeviceBehfa(this.inner_DeviceBehfaFilterGroup.id, item.id).subscribe(
      data => {
        this.Procssing = false
        if (data.id == -1)
          this.Alertify_Service.ErrorMessage("تجهیز در لیست موجود است")
        else {
          this.Alertify_Service.SuccessMessage("ثبت شد")
          this.ReadData_DeviceBehfaFilterGroupUser()
        }
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  //#endregion

}
